import axios from "axios";
import { NEXUS_API_URL } from "@/environments";
import { store } from "@/redux/store";
import { clearAuth } from "@/redux/features/auth-slice";

export enum AddressType {
  SHIPPING = "shipping",
  BILLING = "billing",
}

export interface ClientAddress {
  id: string;
  type: AddressType;
  label?: string;
  street: string;
  houseNumber: string;
  apartmentNumber?: string;
  country?: string;
  floor?: string;
  zipCode: string;
  city: string;
  recipientName?: string;
  phone?: string;
  isDefault: boolean;
  isArchived: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateClientAddressDto {
  type: AddressType;
  label?: string;
  street: string;
  houseNumber: string;
  apartmentNumber?: string;
  country?: string;
  floor?: string;
  zipCode: string;
  city: string;
  recipientName?: string;
  phone?: string;
  isDefault?: boolean;
}

export const nexusApi = axios.create({
  baseURL: NEXUS_API_URL,
});

export const publicNexusApi = axios.create({
  baseURL: NEXUS_API_URL,
});

nexusApi.interceptors.request.use((config) => {
  if (typeof window === "undefined") return config;

  const token = localStorage.getItem("client_token");
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export const handle401Action = () => {
  if (typeof window !== "undefined" && !window.location.pathname.includes("/signin")) {
    store.dispatch(clearAuth());
    window.location.href = "/signin";
  }
};

const handleAxios401Error = (error: any) => {
  if (error?.response?.status === 401) {
    handle401Action();
  }
  return Promise.reject(error);
};

nexusApi.interceptors.response.use((response) => response, handleAxios401Error);
publicNexusApi.interceptors.response.use((response) => response, handleAxios401Error);
